(ns app.front.view.group.admin.import.session-list
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui.table :as ui-table]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::sessions
  (fn [[_ group-id]]
    (rf/subscribe [::entities/entities {:entity/type            :entity.type/import-session
                                        :domain/authority-group group-id}]))
  (fn [sessions _]
    (->> sessions
         (remove (du/in-state-fn :import-session.state/removed))
         (sort-by (juxt :domain/state
                        (comp :entity/created :import-session/file))))))

(defn session->href [session]
  (href/href :view/group.admin.import.session
             {:group-id   (-> session :domain/authority-group :db/id)
              :session-id (:db/id session)}))

(def state->status
  {:import-session.state/in-progress :task
   :import-session.state/done        :ok})

(defn session-list [{:keys [group-id]}]
  (let [tr       (<sub [:tr])
        sessions (<sub [::sessions group-id])]
    (when (seq sessions)
      [:section
       [:h3 (tr [:data-import/sessions])]
       [ui-table/modern-responsive-table
        {:tr         tr
         :link       {:make-href   session->href
                      :description :data-import/open-session}
         :get-status (comp state->status :domain/state)
         :items      sessions
         :cols       [[:file/filename
                       (comp :file/filename :import-session/file)]
                      [:import-session/type
                       #(tr [(:import-session/type %)])]
                      [:domain/state (comp tr vector :domain/state)]
                      [:entity/created
                       (comp (<sub [::date-util/date-fn]) :entity/created)]]}]])))
